module.exports = __webpack_public_path__ + "media/src/images/icons/scissors_icon-ab6f7920bd989eeff6db2eb9c8f96d5c.svg";